const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_[FILL_IN_THE_BLANK]',
  aws_user_pools_web_client_id: '[FILL_IN_THE_BLANK]',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default awsmobile;
